export const zh = {
  app: {
    name: '3DGS Explorer',
  },
  common: {
    newVersionDetected: '检测到新版本，请刷新页面以获取最新内容',
    refreshNow: '立即刷新',
  },
  explore: {
    scaffoldHint: '当前 sceneId =',
  },
  errors: {
    notFound: '页面未找到',
    'missing-scene-id': '缺少 scene-id 参数',
    'scene-offline': '场景已下线',
    'preview-token-invalid': '预览令牌无效或已过期',
    back: '返回',
    'access-denied': '无访问权限',
    'access-denied-desc': '您没有权限查看此场景，请联系创建者获取邀请。',
    'access-denied-login': '去登录',
    'back-to-platform': '返回平台',
    'scene-not-found': '场景不存在',
    'scene-not-found-desc': '您查找的场景不存在或已被删除。',
  },
  scene: {
    by: '创建者',
    noDescription: '暂无描述。',
  },
  share: {
    'link-copied': '链接已复制',
    'copy-failed': '复制失败',
    'copy-permission-denied': '浏览器已拒绝剪贴板权限，请手动复制链接',
    share: '分享',
    'close-share': '关闭分享',
  },
  toolbar: {
    vrMode: 'XR',
    sceneInfo: '场景信息',
    goBack: '返回',
    flyMode: '飞行模式',
    walkMode: '步行漫游',
    orbitMode: '环绕模式',
    screenshot: '视角快照',
    measureTool: '测量工具',
    exitMeasure: '退出测量',
    playCinematic: '播放',
    pauseCinematic: '暂停',
    hotspots: '热点跳转',
    closeHotspots: '关闭热点',
    close: '关闭',
    cancel: '取消',
    vrWebglTitle: '切换 WebGL 模式',
    vrWebglDesc: 'VR 需要使用 WebGL 渲染，页面将重新加载。加载完成后请再次点击 VR 按钮进入。',
    vrWebglConfirm: '切换 WebGL',
    vrQualityTitle: '选择 VR 性能档位',
    vrQualityLowest: '极低',
    vrQualityLow: '低',
    vrQualityMedium: '中',
    vrQualityHigh: '高',
    vrQualityHigher: '较高',
    vrQualityHighest: '极致',
    firstPerson: '第一人称',
    thirdPerson: '第三人称',
    characterRoam: '步行漫游',
    flyDesc: 'QE 升降视角',
    walkDesc: 'Tab 切换视角',
    orbitDesc: '鼠标拖拽画面',
    cinema: '3D 竞速运镜',
    assetLibrary: '资产库',
  },
  raceTrack: {
    pause: '暂停 (空格)',
    play: '播放 (空格)',
    needKeyframes: '至少需要 2 个关键帧才能播放 ({{count}}/2)',
    hidePreview: '隐藏预览',
    showPreview: '显示预览',
    lookMode: '朝向模式',
    lookAuto: '自动',
    lookForward: '前方',
    lookCenter: '中心',
    interpolation: '插值类型',
    interpolationStep: '阶跃',
    interpolationSpline: '样条',
    smooth: '平滑度',
    addKeyframe: '在当前相机位置添加关键帧 (F)',
    updateKeyframe: '将关键帧更新为当前相机 (U)',
    deleteSelected: '删除选中关键帧 (Delete/Backspace)',
    deleteAll: '删除所有关键帧',
    jumpToStart: '跳到开头 (G)',
    jumpToPrevious: '跳到上一个关键帧 (H)',
    jumpToNext: '跳到下一个关键帧 (L)',
    jumpToEnd: '跳到末尾 (;)',
    undoOptimize: '撤销优化',
    optimizeTrack: '优化轨道',
    exportVideo: '导出视频',
    closeEditor: '关闭编辑器',
    timelineTrack: '时间轴轨道',
    keyframeAt: '位于 {{time}}s 的关键帧',
    playhead: '播放头',
    preview: '预览',
    aspectRatio: '宽高比',
    closePreview: '关闭预览',
    loadingPreview: '加载预览中',
    resizeHandle: '调整大小',
    previewFailed: '预览失败',
    exportTitle: '导出视频',
    resolution: '分辨率',
    resolutionSquare: '方形 1080p (1080×1080)',
    resolution1080p: '全高清 1080p (1920×1080)',
    resolution720p: '高清 720p (1280×720)',
    resolutionOriginal: '原始视口',
    frameRate: '帧率',
    fps24: '24 fps (电影)',
    fps30: '30 fps (标准)',
    fps60: '60 fps (流畅)',
    codec: '编码',
    codecH264: 'H.264 / AVC',
    codecVp9: 'VP9',
    codecVp8: 'VP8',
    quality: '质量',
    qualityStandard: '标准',
    qualityHigh: '高',
    qualityUltra: '极致',
    exporting: '导出中…',
    exportProgress: '导出进度',
    exportFailed: '导出失败',
    cancel: '取消',
    sceneNotReady: '场景尚未就绪，无法导出',
    needTwoKeyframes: '至少需要 2 个关键帧才能导出视频',
    sceneTimeout: '场景加载超时，无法开始导出',
    mediaRecorderUnsupported: '当前浏览器不支持 MediaRecorder',
    exportCanvasFailed: '导出录制画布创建失败',
  },
  assetLibrary: {
    title: '资产库',
    close: '关闭',
    translate: '位置',
    rotate: '旋转',
    scale: '缩放',
    dropHint: '拖拽 GLB/GLTF 文件或文件夹，或点击选择',
    urlPlaceholder: '或输入 URL...',
    import: '导入',
    selectModel: '选择一个模型以编辑变换',
    position: '位置',
    rotation: '旋转 (弧度)',
    scaleLabel: '缩放',
    noModels: '尚未导入模型',
    duplicate: '复制模型',
    rename: '重命名',
    delete: '删除模型',
    gltfNotSupported: '.gltf 格式需附带外部资源文件，请转换为 .glb 后再导入',
    importFailed: '模型导入失败，请检查文件格式',
    unsupportedFormat: '仅支持 .glb 和 .gltf 格式文件',
    folderSelect: '选择文件夹',
  },
  hotspots: {
    title: '热点',
    sceneNavigation: '场景导航',
    close: '关闭热点',
    empty: '此场景中没有热点。',
    flyTo: '飞至此兴趣点。',
    previous: '上一个热点',
    next: '下一个热点',
    openHotspot: '打开热点 {{title}}',
    hotspot: '热点',
    closeHotspot: '关闭热点',
    noDescription: '暂无描述。',
  },
  user: {
    feedback: '发送反馈',
    feedbackTitle: '发送反馈',
    feedbackPlaceholder: '请描述您的反馈…',
    feedbackSubmit: '提交（API 接入中）',
    points: '积分',
    pointsLoading: '加载中…',
    pointsAvailable: '积分',
    pointsTotalGranted: '累计获得',
    pointsTotalConsumed: '已消耗',
    pointsFailed: '未登录或获取失败',
    userInfo: '用户信息',
    login: '登录',
    logout: '退出登录',
    notLoggedIn: '未登录',
    user: '用户',
  },
};
